import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import DragAndDropUploader from 'components/ReusableComponents/DragAndDropUploader'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import contractApi from 'services/api/contracts'

import Box from '../Box'
import DocumentTile from './DocumentTile'
import styles from './SubsidiaryDocuments.module.scss'

const SubsidiaryFileTypes = {
  Unknown: 'Unknown',
  Other: 'Other',
  Contract: 'Contract',
  AchAuthForm: 'Ach Auth Form'
}

const UsSubsidaryFileTypes = {
  Unknown: 'Unknown',
  Other: 'Other',
  Contract: 'Contract',
  AchAuthForm: 'Ach Auth Form',
  LegalForm: 'Legal Form'
}

export default function SubsidiaryDocuments(props) {
  const { onClick } = props
  const { addToast } = useToasts()
  const cultureCode = useSelector(s => s.hotelDetails.cultureCode)
  const isUS = cultureCode === 'en-US'

  const [documents, setDocuments] = useState([])

  const [filePickerKey, setFilePickerKey] = useState(0)
  const [showAddDocument, setShowAddDocument] = useState(false)
  const [selectedDocumentType, setSelectedDocumentType] = useState(
    SubsidiaryFileTypes.Other
  )

  function getData() {
    contractApi.documents
      .subsidiary()
      .then(data => setDocuments(data || []))
      .catch(console.error)
  }

  useEffect(() => {
    getData()
  }, [])

  const onFileUploadComplete = res => {
    const jsonRes = JSON.parse(res)

    if (jsonRes.isSuccess) {
      getData()
      setShowAddDocument(false)
      addToast('Document uploaded successfully!', {
        appearance: 'success'
      })
    } else {
      addToast(jsonRes.message || 'Something went wrong while uploading file', {
        appearance: 'error',
        autoDismiss: true
      })
      setFilePickerKey(old => old + 1)
    }
  }

  return (
    <>
      <Box title="Subsidiary Documents">
        <div
          style={{
            marginTop: 6,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: 12
          }}
        >
          {documents.length > 0 ? (
            documents.map(document => (
              <DocumentTile
                key={document.documentId}
                document={document}
                onClick={() => onClick(document)}
              />
            ))
          ) : (
            <p>No documents found</p>
          )}
        </div>
      </Box>

      {showAddDocument && (
        <ConfirmationDialog
          title="Add Document"
          theme="blacklist"
          negativeMessage="OK"
          onClose={() => setShowAddDocument(false)}
          hasConfirmButton={false}
          maxWidth={700}
        >
          <div className={styles.container}>
            <Dropdown
              className={styles.dropdown}
              label="Select Document Type"
              value={selectedDocumentType}
              onChange={e => setSelectedDocumentType(e.target.value)}
              options={isUS ? UsSubsidaryFileTypes : SubsidiaryFileTypes}
            />

            <div className={styles.uploadFormHolder}>
              <DragAndDropUploader
                key={filePickerKey}
                url="/merchantcontracts/subsidiary/documents"
                acceptedFileTypes={['application/pdf', 'image/png', 'image/jpeg']}
                onData={formData => {
                  formData.append('kind', selectedDocumentType)
                  return formData
                }}
                onLoad={onFileUploadComplete}
                onError={() =>
                  addToast('Something went wrong while uploading file', {
                    appearance: 'error',
                    autoDismiss: true
                  })
                }
                labelIdle="
              <p class='filepond-p-micro'>Drag &amp; drop file here  </p>
              <span class='filepond-or-micro'>or</span> <span class='filepond--label-action-micro'>Browse file</span>"
              />
            </div>
          </div>
        </ConfirmationDialog>
      )}
    </>
  )
}
